import { useAtom } from 'jotai'
import styled from 'styled-components'
import { skipBackwardsSecondsAtom, skipForwardsSecondsAtom } from './atoms'
import SkipArrowAnimation from './SkipArrowAnimation'
import SkipSecondsDisplay from './SkipSecondsDisplay'

//* ============================ React component ===============================

const AnimationOverlay = (): JSX.Element => {
  const [backSeconds] = useAtom(skipBackwardsSecondsAtom)
  const [forwardSeconds] = useAtom(skipForwardsSecondsAtom)

  return (
    <Wrapper>
      <LeftItemsRow>
        <Mirror>
          <SkipArrowAnimation seconds={backSeconds} />
        </Mirror>
        <WidthSpacer />
        <SkipSecondsDisplay seconds={backSeconds} />
      </LeftItemsRow>
      <RightItemsRow>
        <SkipSecondsDisplay seconds={forwardSeconds} />
        <WidthSpacer />
        <SkipArrowAnimation seconds={forwardSeconds} />
      </RightItemsRow>
    </Wrapper>
  )
}

export default AnimationOverlay

//* ============================ Styled Components =============================

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  pointer-events: none;
`

const LeftItemsRow = styled.div`
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const RightItemsRow = styled.div`
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translate(50%, -50%);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const WidthSpacer = styled.div`
  width: 20px;
`

const Mirror = styled.div`
  transform: scaleX(-1);
`
